<!-- 签到福利 -->
<template>
  <div :class="$style.signin">
    <lazy-component>
      <div style="height: 0.9rem" v-html="signinRule" />
      <ul :class="$style['signin-list']">
        <li
          v-for="item in finalSigninList"
          :key="item.award_id"
          :style="{
            backgroundImage: `url(${item.picture})`,
            backgroundPosition: item.is_award === 1 && item.is_sign === 1 ? '100% 0' : '0 0'
          }"
        />
      </ul>
      <div style="position: relative">
        <button
          :disabled="isSigninToday || isCompleteSignin"
          :class="$style['btn-signin']"
          @click="handleReservation"
        />
        <button v-if="isBindRole" :class="$style['btn-award']" @click="$emit('show-records')">
          我的奖品
        </button>
      </div>
      <popup-frame ref="result">
        <div :class="$style['signin-result']">
          <div style="height: 1.4rem; position: relative; z-index: 1">
            恭喜团长获得第
            <em>{{ signinDays }}</em>
            天 【签到福利】-<br /><em>{{ giftName }}</em> ！ <br />
            <span v-if="signinDays === signinGetLotteryTicketDay">
              {{ signinGetLotteryTicketTip }}
            </span>
            <template v-else>奖励已发放至<em>游戏内邮箱中</em>，请前往游戏领取！</template>
          </div>
          <img :src="giftImg" style="width: 5.7rem; height: 2.19rem" />
        </div>
      </popup-frame>
    </lazy-component>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { PopupFrame } from '@/components/widgets'
import { signin, collectSigninAward, fetchSigninInfo, fetchUserInfo } from '@/api'
import { getQueryString } from '@/utils'

export default {
  name: 'TheSignin',
  props: {
    dataSource: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      giftName: '',
      giftImg: ''
    }
  },
  components: {
    PopupFrame
  },
  computed: {
    ...mapGetters([
      'signinRule',
      'isBindRole',
      'isSigninToday',
      'signinDays',
      'isCompleteSignin',
      'isDebug',
      'signinList',
      'signinGetLotteryTicketDay',
      'signinGetLotteryTicketTip'
    ]),
    /** 将签到列表的数据与dataSource进行合并生成最终的签到列表 */
    finalSigninList() {
      const list = this.dataSource.map((item, index) => {
        const signinItem = this.signinList[index]
        return {
          ...item,
          ...signinItem
        }
      })
      return list
    }
  },
  methods: {
    ...mapActions(['setOwnedGifts', 'setSigninInfo', 'updateAppData']),
    handleReservation() {
      if (!this.isBindRole) {
        this.$emit('login')
        return
      }
      this.reserveGift()
    },
    async reserveGift() {
      // 今天是签到第几天
      const todaySigninIndex = this.isSigninToday ? this.signinDays : this.signinDays + 1
      // 获取当天签到项
      const todaySigninItem = this.finalSigninList[todaySigninIndex - 1]

      let giftId, giftImg

      if (todaySigninItem.is_sign !== 1) {
        // 今日未签到
        const { data = {} } = await signin(this.isDebug && { test_time: getQueryString('t') })
        if (data.sign_day_data) {
          const giftItem = Object.values(data.sign_day_data).find(
            item => item.is_sign === 1 && item.is_award !== 1
          )
          giftId = giftItem.award_id
          giftImg = this.finalSigninList.find(item => item.award_id === Number(giftId)).result_img
          this.setSigninInfo(data)
        }
      } else {
        // 今日已签到
        giftId = todaySigninItem.award_id
        giftImg = todaySigninItem.result_img
      }

      if (!giftId) {
        return
      }

      // 开始领奖
      const collectRes = await collectSigninAward(giftId)
      if (collectRes.code === 0) {
        this.giftName = collectRes.data.award_name
        this.giftImg = giftImg
        this.initSignin()
        this.initUser()
        this.$refs.result.show()
      }
    },
    async initSignin() {
      const { data = {} } = await fetchSigninInfo(
        this.isDebug && { test_time: getQueryString('t') }
      )
      if (Object.keys(data).length > 0) {
        this.setSigninInfo(data)
      }
    },
    async initUser() {
      const { data = {} } = await fetchUserInfo()
      if (Object.keys(data).length > 0) {
        // 设置活动相关数据
        this.updateAppData(data)
      }
    }
  }
}
</script>

<style lang="less" module>
.signin {
  .background-fill('./images/signin-bg.jpg');

  height: 14.36rem;
  padding-top: 3.5rem;
  line-height: 1.6;
  text-align: center;

  &-list {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    height: 8.7rem;
    margin-left: 0.7rem;

    li {
      .size(1.92rem, 2.43rem);

      background-size: 200% 100%;
      background-repeat: no-repeat;
      margin: 0 0.22rem 0.14rem 0;

      &:last-child {
        .size(4.1rem, 2.48rem);
      }
    }
  }

  &-result {
    padding-top: 0.4rem;
    text-align: center;
    line-height: 1.5;

    &::after {
      .size(6.9rem, 2.89rem);
      .background-fill('./images/result-title.png');

      content: '';
      position: absolute;
      top: 0;
      left: 0;
      pointer-events: none;
    }
  }
}

.btn-signin {
  .size(3.06rem, 0.88rem);
  .background-fill('./images/btn-signin.png', 100% 200%);

  display: inline-block;

  &:disabled {
    background-position: 0 100%;
  }
}

.btn-award {
  position: absolute;
  top: 0.4rem;
  left: 50%;
  transform: translateX(1.65rem);
  border-bottom: 1px solid #e4674d;
  color: #e4674d;
}
</style>
